import React from 'react';

function Header2({ text }) {

    return (
        <h2>{text ?? ""}</h2>
    );
}

export default Header2;